import type { JSX } from 'react';
import { useEffect } from 'react';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';
import { useProcessActivityEditContextMergedProps } from '@frontend/utils';

export function FormParagraphFormGroupPrefilled({
    fieldKey,
    label,
    value,
}: Readonly<{
    fieldKey: string;
    label: string;
    value: string;
}>): JSX.Element {
    const { onChange } = useProcessActivityEditContextMergedProps<{
        fieldKey: string;
        onChange: (value: string | null) => void;
    }>({ fieldKey });

    useEffect(() => {
        onChange(value);

        return () => {
            onChange(null);
        };
    }, []);

    return <FormParagraphFormGroup label={label}>{value}</FormParagraphFormGroup>;
}
